export default "__VITE_ASSET__C5bAg3Os__"